import { Globe } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';
import { Button } from '@/components/ui/button';

interface LanguageSwitcherProps {
  variant?: 'header' | 'mobile';
  className?: string;
}

export function LanguageSwitcher({ variant = 'header', className = '' }: LanguageSwitcherProps) {
  const { language, toggleLanguage } = useLanguage();

  const displayText = language === 'he' ? 'EN' : 'עב';

  if (variant === 'mobile') {
    return (
      <Button
        variant="outline"
        onClick={toggleLanguage}
        className={`w-full gap-2 ${className}`}
        aria-label={language === 'he' ? 'Switch to English' : 'החלף לעברית'}
      >
        <Globe className="w-4 h-4" />
        {language === 'he' ? 'English' : 'עברית'}
      </Button>
    );
  }

  return (
    <button
      onClick={toggleLanguage}
      className={`flex items-center gap-1.5 px-3 py-2 rounded-xl font-medium transition-all duration-300 text-primary-foreground/85 hover:bg-primary-foreground/10 hover:text-primary-foreground ${className}`}
      aria-label={language === 'he' ? 'Switch to English' : 'החלף לעברית'}
    >
      <Globe className="w-4 h-4" />
      <span className="text-sm font-semibold">{displayText}</span>
    </button>
  );
}
